import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react'
import Label from './Label';
import FormElement from './FormElement';

let RadioLabel = styled.label`
	font-weight: 400;
	margin-right: 2em;
	padding: 1em 0;
	flex-basis: ${props => props.basis};

	&:last-child {
		margin-right: 0;
	}

	${props => props.theme.radioLabel || ''}
`;

const Radio = css`
	-webkit-appearance: radio;
	margin-right: 0.5em;
`;

const RadioWrap = styled.div`
	${props => props.theme.radioWrap || ''}
`;

const Wrapper = FormElement.withComponent('div');

export default function StyledInputRadio(props) {
	return (
		<Wrapper radio>
			<Label>{props.label}</Label>
			<RadioWrap>
				{props.radio.map(radio => {
					return (
						<RadioLabel
							basis={`${100 / props.radio.length}%`}
							{...props.passedProps}
							key={radio.value}
						>
							<input
								css={Radio}
								type="radio"
								name={props.name}
								onChange={props.onChange}
								onBlur={props.onBlur}
								value={radio.value}
								checked={props.value == radio.value} // eslint-disable-line eqeqeq
							/>
							{radio.name}
						</RadioLabel>
					);
				})}
			</RadioWrap>
		</Wrapper>
	);
}
